export default "__VITE_ASSET__CL8EtA$0__"